import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideSoundEmissionInfoBox } from "../../redux/soundEmission";
import ConfigurationLayout from "./ConfigurationLayout";
import "./SoundEmissionInfoBox.css";
import "./VirtualSensorsInfoBox.css";

const formatNumber = (value, digits = 2) =>
  Number.isFinite(Number(value)) ? Number(value).toFixed(digits) : "—";

const Detail = ({ label, children }) => (
  <div className="sensor-info-item">
    <span className="sensor-info-label">{label}:</span>{" "}
    <span className="sensor-info-value">{children}</span>
  </div>
);

const SoundEmissionInfoBox = () => {
  const dispatch = useDispatch();
  const {
    infoBoxShow,
    isVisible,
    selectedPoint: point,
  } = useSelector((state) => state.soundEmission);

  if (!isVisible || !infoBoxShow || !point) return null;

  return (
    <ConfigurationLayout
      title="Sound Emission Information:"
      onClickOutside={() => dispatch(hideSoundEmissionInfoBox())}
      style={{ height: "600px", overflowY: "auto" }}
    >
      <div className="sensor-info-box sound-emission-info-box">
        <Detail label="Max allowable sound power">
          {formatNumber(point.max_allowable_lw)}{" "}
          <span className="unit">dB(A)</span>
        </Detail>
        <Detail label="Candidate ID">#{point.id}</Detail>
        <Detail label="Position">
          X {formatNumber(point.x)}, Y {formatNumber(point.y)}, Z{" "}
          {formatNumber(point.z)}
        </Detail>
        <Detail label="Propagation mode">{point.di_mode}</Detail>
        <Detail label="Surface condition">{point.k0_mode}</Detail>
        <Detail label="Correction factors">
          K0 {point.k0}, Kr {point.k_r}, Kt {point.k_t}
        </Detail>
        <Detail label="Nearest surface">
          {formatNumber(point.nearest_surface)} <span className="unit">m</span>
        </Detail>
        <Detail label="Receiver distance">
          {formatNumber(point.di_receiver_distance)}{" "}
          <span className="unit">m</span>
        </Detail>
        <Detail label="Receiver position">
          X {formatNumber(point.di_receiver_x)}, Y{" "}
          {formatNumber(point.di_receiver_y)}, Z{" "}
          {formatNumber(point.di_receiver_z)}
        </Detail>
      </div>
    </ConfigurationLayout>
  );
};

export default SoundEmissionInfoBox;
